import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useCandidateSourcedFrom() {
  const api = useAxios();

  const { data, isLoading } = useQuery({
    queryKey: ["candidate-sourced-from"],
    queryFn: () => api.get("/candidates/sourced-from"),
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { sourcedFrom: data?.data ?? [], isLoading };
}
